import { BreadcrumbLabels } from '@shared/enums/breadcrumb-labels.enum';

export const BreadcrumbIcons = {
  [BreadcrumbLabels.Dashboard]: 'home',
  [BreadcrumbLabels.Shipments]: 'shipments',
  [BreadcrumbLabels.ShipmentsView]: 'shipments',
  [BreadcrumbLabels.Providers]: 'fleet',
  [BreadcrumbLabels.LiveTracking]: 'live-tracking',
  [BreadcrumbLabels.Invoices]: 'invoices',
  [BreadcrumbLabels.Settings]: 'manage',
  [BreadcrumbLabels.Orders]: 'location-alt.svg',
  [BreadcrumbLabels.Contracts]: 'manage',
  [BreadcrumbLabels.TripPlanning]: 'bulk-routing',
  [BreadcrumbLabels.CustomersInvoices]: 'invoices',
  [BreadcrumbLabels.FleetsInvoices]: 'invoices',
  [BreadcrumbLabels.Customers]: 'customers',
  [BreadcrumbLabels.B2cShipments]: 'aggregator',
  [BreadcrumbLabels.FleetsB2c]: 'aggregator',
  [BreadcrumbLabels.FleetB2c]: 'aggregator',
  [BreadcrumbLabels.Rules]: 'aggregator',
  [BreadcrumbLabels.SalesOrders]: 'shipments',
  [BreadcrumbLabels.Payments]: 'transportation-payments',
  [BreadcrumbLabels.Users]: 'manage',
  [BreadcrumbLabels.ManageReceivers]: 'manage',
  [BreadcrumbLabels.Organizations]: 'manage',
  [BreadcrumbLabels.TripPerformance]: 'manage',
  [BreadcrumbLabels.OnlinebookingLeads]: 'customers',
};
